import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import { getRelativeDay } from '@utils/dates';
import { Fonts, Spacings } from '@styles/index';
import {
  plannerItemTypeHeightMap,
  dayTitleLeftSpacing
} from '../planner-constants';

const Wrapper = styled.div`
  padding-top: ${Spacings.SPACING_10B};
  padding-left: ${dayTitleLeftSpacing};
  position: sticky;
  z-index: 2;
  top: -1px;
  background-color: var(--color-base-0);
  height: ${({ $height }) => $height}px;
  width: ${`calc(100% + ${Spacings.SPACING_5B})`};
`;

const Title = styled(H4)`
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const DayTitle = ({ metaItem }) => {
  const { date, title, plannerItemType } = metaItem;
  return (
    <>
      <Wrapper
        $height={plannerItemTypeHeightMap[plannerItemType]}
        className="day-title"
        data-date={date}
      >
        <Title>{getRelativeDay(date) || title}</Title>
      </Wrapper>
    </>
  );
};

export default DayTitle;
